import { render, staticRenderFns } from "./ApplySence.vue?vue&type=template&id=65d673ce&scoped=true"
import script from "./ApplySence.vue?vue&type=script&lang=js"
export * from "./ApplySence.vue?vue&type=script&lang=js"
import style0 from "./ApplySence.vue?vue&type=style&index=0&id=65d673ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d673ce",
  null
  
)

export default component.exports